import { NgModule } from '@angular/core';
import { TagCommandComponentModule, DeleteZeitCommandModule, KrankheitCommandComponentModule, PostZeitCommandModule, RahmenAnpassungCommandComponentModule, UrlaubCommandComponentModule } from '.';

@NgModule({
  declarations: [],
  imports: [TagCommandComponentModule, RahmenAnpassungCommandComponentModule, UrlaubCommandComponentModule, KrankheitCommandComponentModule, PostZeitCommandModule, DeleteZeitCommandModule],
  exports: [TagCommandComponentModule, RahmenAnpassungCommandComponentModule, UrlaubCommandComponentModule, KrankheitCommandComponentModule, PostZeitCommandModule, DeleteZeitCommandModule],
})
export class ZeitenCommandsModule {}
